export async function uploadElementFile(elem, input) {
    const fileElem = document.getElementById(elem);
    if (fileElem) {
        fileElem.click();
        await fileElem.addEventListener(
            "change",
            () => {
                // Calculate total size
                let numberOfBytes = 0;
                for (const file of fileElem.files) {
                    numberOfBytes += file.size;
                }
                // Approximate to the closest prefixed unit
                const units = [
                    "B",
                    "KiB",
                    "MiB",
                    "GiB",
                    "TiB",
                    "PiB",
                    "EiB",
                    "ZiB",
                    "YiB",
                ];
                const exponent = Math.min(
                    Math.floor(Math.log(numberOfBytes) / Math.log(1024)),
                    units.length - 1
                );
                const approx = numberOfBytes / 1024 ** exponent;
                const output =
                    exponent === 0
                        ? `${numberOfBytes} bytes`
                        : `${approx.toFixed(3)} ${ units[exponent] } (${numberOfBytes} bytes)`;

                input.show = true;
            },
            false
        );
    }
}

export async function validateUploadFile(elem ,input, pattern1 = "", pattern2 = "", inputType, studentFullNameTh, studentFullNameEn, locale) {
    const fileElem = elem;
    const maxFileSize = (1024 * 1000 * 10); // 10 Mb
    if (fileElem) {
        // Calculate total size
        let numberOfBytes = 0;
        for (const file of fileElem.files) {
            numberOfBytes += file.size;
        }
        // Approximate to the closest prefixed unit
        const units = [
            "B",
            "KiB",
            "MiB",
            "GiB",
            "TiB",
            "PiB",
            "EiB",
            "ZiB",
            "YiB",
        ];

        const exponent = Math.min(
            Math.floor(Math.log(numberOfBytes) / Math.log(1024)),
            units.length - 1
        );
        const approx = numberOfBytes / 1024 ** exponent;
        const output = exponent === 0 ? `${numberOfBytes} bytes` : `${approx.toFixed(3)} ${units[exponent]} (${numberOfBytes} bytes)`;

        input.show = true;
        input.fileName = fileElem.files[0].name;
        input.fullFileName = fileElem.files[0].name;
        if (inputType.includes(fileElem.files[0].type) && (numberOfBytes <= maxFileSize)) {
            // eslint-disable-next-line
            const fileRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]/;
            if(fileRegex.test(input.fileName)){
                input.fileName = 'message.adminPage.file.changeFileName';
                input.color = "red";
                fileElem.value = "";
                return
            }

            // if (input.fullFileName.match(`${pattern1}_([\u0E00-\u0E7Fa-zA-Z]{1,50})_([\u0E00-\u0E7Fa-zA-Z]{1,50}).pdf`) ||
            //     input.fullFileName.match(`${pattern2}_([\u0E00-\u0E7Fa-zA-Z]{1,50})_([\u0E00-\u0E7Fa-zA-Z]{1,50}).pdf`)) {
            //     if (input.fileName.length > 25)
            //         input.fileName = input.fileName.substring(0, 25) + "...";
            //     input.color = "orange";
            //     input.file = fileElem.files[0];
            //     return
            // }
            // else {
            //     input.fileName = 'message.adminPage.file.createNew';
            //     input.color = "red";
            //     fileElem.value = "";
            //     return
            // }

            input.color = "orange";
            input.file = fileElem.files[0];
            const newFileName = locale == 'th' ? `${pattern1}_${studentFullNameTh}.pdf` : `${pattern2}_${studentFullNameEn}.pdf`;
            input.fullFileName = newFileName;
            input.fileName = newFileName
            //if (input.fileName?.length > 25) input.fileName = input.fileName.substring(0, 25) + "...";
        } else {
            // if (numberOfBytes > (1000000 * 5)) {
                //invalid type
                input.fileName = (numberOfBytes > maxFileSize) ? 'message.adminPage.file.overSize' : 'message.adminPage.file.requirePDFFile';
                input.color = "red";
                fileElem.value = "";
                return
            // }
            // else{
            //     if (input.fileName.length > 25)
            //     input.fileName = input.fileName.substring(0, 25) + "...";
            //     input.color = "orange";
            //     input.file = fileElem.files[0];
            //     return
            // }
        }
    }
}

export async function validateUploadImageFile(elem ,input, inputType = []){
    const fileElem = elem;
    if (fileElem) {
        // Calculate total size
        let numberOfBytes = 0;
        for (const file of fileElem.files) {
            numberOfBytes += file.size;
        }
        // Approximate to the closest prefixed unit
        const units = [
            "B",
            "KiB",
            "MiB",
            "GiB",
            "TiB",
            "PiB",
            "EiB",
            "ZiB",
            "YiB",
        ];
        const exponent = Math.min(
            Math.floor(Math.log(numberOfBytes) / Math.log(1024)),
            units.length - 1
        );
        const approx = numberOfBytes / 1024 ** exponent;
        const output =
            exponent === 0
                ? `${numberOfBytes} bytes`
                : `${approx.toFixed(3)} ${ units[exponent] } (${numberOfBytes} bytes)`;

        input.show = true;
        input.fileName = fileElem.files[0].name;
        input.fullFileName = fileElem.files[0].name;
        let validateType = false;
        for(var type of inputType){
            validateType = type.includes(fileElem.files[0].type) || validateType
        }
        if (validateType) {
            if (input.fileName?.length > 25) input.fileName = input.fileName.substring(0, 25) + "...";

            input.color = "orange";
            input.file = fileElem.files[0];
            return
        } else {
            //invalid type
            input.fileName = 'message.adminPage.file.errorUpload';
            input.color = "red";
            fileElem.value = "";
            return
        }
    }
}
